import { FulfillmentType, FulfillmentTypeEnum } from '../../../../../mixins/enums/FulfillmentType.js';
import { useDate } from '@/composables/useDate.js';

const { parseDate, add } = useDate();

export const TentativeDateEnum = Object.freeze({
    DAY_0: 'day-before',
    DAY_1: 'day-1',
    DAY_2: 'day-2',
    DAY_3: 'day-3',
    DAY_4: 'day-4',
    DAY_5: 'day-5',
    DAY_6: 'day-6',
    DAY_7: 'day-7',
});

export const TentativeDateArray = [
    TentativeDateEnum.DAY_0,
    TentativeDateEnum.DAY_1,
    TentativeDateEnum.DAY_2,
    TentativeDateEnum.DAY_3,
    TentativeDateEnum.DAY_4,
    TentativeDateEnum.DAY_5,
    TentativeDateEnum.DAY_6,
    TentativeDateEnum.DAY_7,
];

export const TentativeDayValueMap = Object.freeze({
    'day-before': -1,
    'day-1': 0,
    'day-2': 1,
    'day-3': 2,
    'day-4': 3,
    'day-5': 4,
    'day-6': 5,
    'day-7': 6,
});

export const TentativeDateOptionsMixin = {
    data() {
        return {
            packageOptions: [
                { int: 0, value: TentativeDateEnum.DAY_0, displayName: this.$t('Day before') },
                { int: 1, value: TentativeDateEnum.DAY_1, displayName: this.$t('Day 1') },
                { int: 2, value: TentativeDateEnum.DAY_2, displayName: this.$t('Day 2') },
                { int: 3, value: TentativeDateEnum.DAY_3, displayName: this.$t('Day 3') },
                { int: 4, value: TentativeDateEnum.DAY_4, displayName: this.$t('Day 4') },
                { int: 5, value: TentativeDateEnum.DAY_5, displayName: this.$t('Day 5') },
                { int: 6, value: TentativeDateEnum.DAY_6, displayName: this.$t('Day 6') },
                { int: 7, value: TentativeDateEnum.DAY_7, displayName: this.$t('Day 7') },
            ],
        };
    },
    computed: {
        tentativeDateOptions() {
            let tentativeConfig = this.tentativeConfig;
            let options = null;
            if (tentativeConfig.type === 'package') {
                options = this.packageOptions;
            } else {
                let startDate = tentativeConfig?.parent?.start_at || new Date();
                options = [];
                if (
                    this.tentativeObject &&
                    this.tentativeObject.fulfillment_type === FulfillmentTypeEnum.ARRANGED_LATER
                ) {
                    options.push({
                        int: 1,
                        value: null,
                        displayName: this.$t('Arranged later'),
                        dropdownName: this.$t('Arranged later'),
                    });
                }
                for (let i = -1; i < 14; i++) {
                    let thisDateValue = parseDate(add(startDate, i, 'days'), 'yyyy-MM-dd');
                    let thisDateDisplay = parseDate(add(startDate, i, 'days'), 'dd/MM/yy');
                    options.push({
                        int: i + 1,
                        value: thisDateValue,
                        displayName: thisDateDisplay,
                        dropdownName:
                            i === -1
                                ? this.$t('Day before') + ' (' + thisDateDisplay + ')'
                                : this.$t('Day') + ' ' + (i + 1) + ' (' + thisDateDisplay + ')',
                    });
                }
            }
            return options;
        },
        tentativeDateOptionsWithNull() {
            let options = this.tentativeDateOptions;
            options.push({
                int: null,
                value: null,
                displayName: this.$t('TBD'),
                dropdownName: this.$t('TBD'),
            });
            return options;
        },
    },
    methods: {
        tentativeDateDisplayName(tentativeDate) {
            return (
                (this.tentativeDateOptionsWithNull.find((options) => options.value === tentativeDate) || {})
                    .displayName || null
            );
        },
        tentativeSectionDays(tentativeSection) {
            if (FulfillmentType.isArrangedLater(tentativeSection)) {
                return 1;
            } else {
                let start =
                    (
                        this.tentativeDateOptions.find(
                            (dateOption) => dateOption.value === tentativeSection.start_date
                        ) || {}
                    ).int || 0;
                let end =
                    (
                        this.tentativeDateOptions.find(
                            (dateOption) => dateOption.value === tentativeSection.end_date
                        ) || {}
                    ).int || 0;
                return end - start + 1;
            }
        },
        tentativeServiceDays(tentativeService) {
            if (tentativeService.section_fulfillment_type == FulfillmentTypeEnum.ARRANGED_LATER) {
                return 1;
            } else {
                // TODO: Check why
                let startOption = this.tentativeDateOptions.find(
                    (dateOption) => dateOption.value === tentativeService.start_date
                );
                let endOption = this.tentativeDateOptions.find(
                    (dateOption) => dateOption.value === tentativeService.end_date
                );

                if (startOption && endOption) {
                    let start = startOption.int;
                    let end = endOption.int;
                    return end - start + 1;
                } else {
                    return 0;
                }
            }
        },
    },
};
